
import { Vue } from "vue-class-component";

export default class CustomProcessBreadcrumb extends Vue {}
